import React from "react";
import main from "../../images/LandingPageImage/business_for_all.webp";
import printer from "../../images/LandingPageImage/pos_solution.webp";
import box from "../../images/LandingPageImage/smart_inventory.webp";
import bike from "../../images/LandingPageImage/delivery_solution.webp";
import { Check } from "lucide-react";

const BuiltForBusiness = () => {
  return (
    <section className="relative py-16 bg-[#f9fdfb] overflow-hidden md:py-20 sm:py-12">
      {/* Background Layer */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${main})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
          backgroundSize: "cover",
          filter: "brightness(0.9)",
        }}
      ></div>

      <div className="relative z-10 text-center px-5">
        {/* Heading */}
        <h2 className="montserrat-font-1 text-3xl md:text-4xl font-bold text-green-700 mb-4">
          Designed for Restaurants to Increase Profits
        </h2>

        {/* Paragraph */}
        <p className="montserrat-font-2 text-gray-700 mb-12 max-w-[500px] mx-auto leading-relaxed">
          From promotions to customer follow-ups, Anlook simplifies restaurant
          marketing. Engage diners better, reduce manual effort and grow sales
          effortlessly.
        </p>

        {/* Cards */}
        <div className="flex flex-wrap justify-center gap-6 max-w-[900px] mx-auto">
          {/* Card 1 */}
          <div className="border-2 border-green-500 rounded-2xl p-6 bg-white flex flex-col items-center text-center w-[250px] h-[340px]">
            <img
              src={printer}
              alt="POS"
              className="w-24 h-24 mb-4 object-contain"
            />
            <h5 className="montserrat-font-1 font-semibold text-lg mb-3">
              Free POS Billing Software
            </h5>
            <ul className="montserrat-font-2 text-gray-600 text-sm space-y-1">
              <li>Quick billing process</li>
              <li>Easy staff usage</li>
              <li>Live sales reports</li>
            </ul>
          </div>

          {/* Card 2 */}
          <div className="border-2 border-green-500 rounded-2xl p-6 bg-white flex flex-col items-center text-center w-[250px] h-[340px]">
            <img
              src={box}
              alt="Inventory"
              className="w-24 h-24 mb-4 object-contain"
            />
            <h5 className="montserrat-font-1 font-semibold text-lg mb-3">
              Smart Inventory Management
            </h5>
            <ul className="montserrat-font-2 text-gray-600 text-sm space-y-1">
              <li>Auto stock updates</li>
              <li>Low-stock alerts</li>
              <li>Waste reduction</li>
            </ul>
          </div>

          {/* Card 3 */}
          <div className="border-2 border-green-500 rounded-2xl p-6 bg-white flex flex-col items-center text-center w-[250px] h-[340px]">
            <img
              src={bike}
              alt="Delivery"
              className="w-24 h-24 mb-4 object-contain"
            />
            <h5 className="montserrat-font-1 font-semibold text-lg mb-3">
              Delivery Management Solution
            </h5>
            <ul className="montserrat-font-2 text-gray-600 text-sm space-y-1">
              <li>Centralized delivery control</li>
              <li>Live order tracking</li>
              <li>Faster deliveries</li>
            </ul>
          </div>
        </div>

        {/* Lower Costs Section */}
        <div className="mt-12 px-5 md:px-0">
          <div className="w-full max-w-[760px] mx-auto rounded-3xl border-2 border-green-500 bg-white p-6 md:p-8 shadow-sm">
            <div className="text-center mb-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-green-100 px-4 py-2 text-sm font-semibold text-green-700 mb-4">
                <Check size={16} strokeWidth={3} />
                Better Profit Control
              </span>

              <h4 className="montserrat-font-1 text-2xl md:text-3xl font-bold text-green-800">
                Lower Costs, Higher Profits
              </h4>

              <p className="mt-3 montserrat-font-2 text-gray-600 text-sm md:text-base max-w-[520px] mx-auto">
                Keep your business simple, transparent, and more profitable.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="rounded-2xl bg-white border border-green-100 p-5 text-center shadow-sm">
                <div className="w-11 h-11 bg-green-500 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check size={20} strokeWidth={3} />
                </div>
                <h6 className="montserrat-font-1 font-bold text-green-800 mb-2">
                  No Hidden Commissions
                </h6>
                <p className="montserrat-font-2 text-sm text-gray-600">
                  Clear pricing without unexpected deductions.
                </p>
              </div>

              <div className="rounded-2xl bg-white border border-green-100 p-5 text-center shadow-sm">
                <div className="w-11 h-11 bg-green-500 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check size={20} strokeWidth={3} />
                </div>
                <h6 className="montserrat-font-1 font-bold text-green-800 mb-2">
                  One Simple Platform
                </h6>
                <p className="montserrat-font-2 text-sm text-gray-600">
                  Manage everything from one easy dashboard.
                </p>
              </div>

              <div className="rounded-2xl bg-white border border-green-100 p-5 text-center shadow-sm">
                <div className="w-11 h-11 bg-green-500 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check size={20} strokeWidth={3} />
                </div>
                <h6 className="montserrat-font-1 font-bold text-green-800 mb-2">
                  More Control
                </h6>
                <p className="montserrat-font-2 text-sm text-gray-600">
                  Better control over orders, pricing, and profits.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuiltForBusiness;
